import React from 'react';
import { OutlinedInput } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { searchInputSx } from '../../../utils/searchInputStyles';
import SearchEndAdornment from '../../../components/SearchBar/components/SearchEndAdornment';

interface MyContentsSearchBarProps {
  value: string;
  setValue: (value: string) => void;
  onSearch: () => void;
  onClear: () => void;
}

const MyContentsSearchBar: React.FC<MyContentsSearchBarProps> = ({ value, setValue, onSearch, onClear }) => {
  const { t } = useTranslation();

  return (
    <OutlinedInput
      data-testid='my-contents-search-bar'
      fullWidth
      role='searchbox'
      value={value}
      onChange={e => setValue(e.target.value)}
      onKeyDown={e => {
        if (e.key === 'Enter') {
          onSearch();
        }
      }}
      placeholder={t('Search materials by title ...')}
      inputProps={{
        'aria-label': t('Search materials by title'),
      }}
      sx={searchInputSx}
      endAdornment={
        <SearchEndAdornment
          value={value}
          onClear={onClear}
          onSearch={onSearch}
        />
      }
    />
  );
};

export default MyContentsSearchBar;
